import { gql, useQuery } from '@apollo/client';
import React, { useMemo } from 'react';
import useDigitalData from '../../hooks/useDigitalData';
import useTranslatedText from '../../hooks/useTranslatedText';
import $window from '../../tools/window';
import { DD_PDP_SUGGESTED_SEARCH_DATA_OBJECT } from '../DigitalDataProvider';
import SearchChoiceButton from '../SearchChoiceButton/SearchChoiceButton';
import pdpSuggestedSearchesStyles from './PdpSuggestedSearches.module.scss';
import buildPdpSuggestedSearchesOptions from './tools/buildPdpSuggestedSearchesOptions';
import formatPdpAttributesFromDatabridge from './tools/formatPdpAttributesFromDatabridge';

const PdpSuggestedSearches = () => {
  const getConfig = gql`
    query ConfigFlags {
      config {
        pdpSuggestedSearches: nonCachedGenericType(name: "pdpSuggestedSearches")
      }
    }
  `;

  const { data: configData } = useQuery(getConfig);

  const {
    pdpSuggestedSearches: { value: pdpSuggestedSearchesEnabled } = {},
  } = configData?.config || {};

  const handlePdpSearchSuggestionClick = (event) => {
    const pdpSearchClickEvent = new CustomEvent('pdp-suggested-search-clicked', { detail: { event } });
    $window.dispatchEvent(pdpSearchClickEvent);
  };

  const {
    [DD_PDP_SUGGESTED_SEARCH_DATA_OBJECT]: suggestedSearchDatabridgeObject,
  } = useDigitalData([DD_PDP_SUGGESTED_SEARCH_DATA_OBJECT]);

  const pdpDatabridgeAttributes = formatPdpAttributesFromDatabridge(
    suggestedSearchDatabridgeObject || {},
  );

  const allL2sSearchButtonText = useTranslatedText('allProducts', {
    fallback: 'All',
    replacements: [pdpDatabridgeAttributes.l1, pdpDatabridgeAttributes.l2],
  });

  const pdpSuggestedSearchesOptionsArray = useMemo(() => buildPdpSuggestedSearchesOptions(
    pdpDatabridgeAttributes, allL2sSearchButtonText?.value,
  ), [pdpDatabridgeAttributes, allL2sSearchButtonText]);

  const pdpSuggestedSearchesTitle = useTranslatedText('searchSimilarTo', {
    fallback: 'Search Similar Products',
    replacements: [pdpDatabridgeAttributes.productName],
  });

  return (
    pdpSuggestedSearchesOptionsArray.length === 0 || !pdpSuggestedSearchesEnabled ? null : (
      <div className={pdpSuggestedSearchesStyles.pdpSuggestedSearchContainer}>
        { pdpSuggestedSearchesTitle?.value ? <h3 className="h3">{pdpSuggestedSearchesTitle?.value}</h3> : null }
        <div className={pdpSuggestedSearchesStyles.searchChoiceButtonContainer}>
          {pdpSuggestedSearchesOptionsArray.map((option) => (
            <SearchChoiceButton
              key={option.key}
              dataType="pdp-suggested-search"
              eventHandler={handlePdpSearchSuggestionClick}
              option={option}
            />
          ))}
        </div>
      </div>
    )
  );
};

export default PdpSuggestedSearches;
